function openLightbox(videoLink, collectionLink,lightboxBtnTxt) {
    // console.log("Button is Working");

    // Create the lightbox container
    const lightboxContainer = document.createElement("div");
    lightboxContainer.id = "lightbox-overlay";
    lightboxContainer.innerHTML = `
        <div class="lightbox-container">
            <div class="close-popup">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" title="Close">
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"/>
                </svg>
            </div>
            <div class="lightbox-container-element video-wrapper">
                <video class="lightbox-container-element popup-video" playsinline="playsinline" autoplay="autoplay" controls="controls" preload="metadata">
                    <source src="${ videoLink }" type="video/mp4">
                </video>
            </div>
            <div class="lightbox-container-element video-controls">
                <button id="rewind-button" class="lightbox-container-element control-button">
                    <svg class="lightbox-container-element" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"/>
                    </svg>
                3 seconds
                </button>
                <button id="forward-button" class="lightbox-container-element control-button">
                    <svg class="lightbox-container-element" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"/>
                    </svg>
                5 seconds
                </button>
            </div>
            <div class="lightbox-container-element collection-link-container">
                <a href='${ collectionLink }' class="lightbox-container-element collection-link" target="_blank">${ lightboxBtnTxt }</a>
            </div>
        </div>
    `;

    // Append the lightbox container to the body
    document.body.appendChild(lightboxContainer);

    // Close lightbox if clicked outside the video or link
    lightboxContainer.addEventListener("click", (e) => {
        // Check if the click is outside the video or the link
        if (!e.target.closest('.lightbox-container-element')) {
            // Remove the lightbox container if clicked outside
            document.body.removeChild(lightboxContainer);
        }
    });

    // Get the video element
    const videoElement = lightboxContainer.querySelector("video");
    const videoWrapper = lightboxContainer.querySelector(".lightbox-container")
    const videoControls = lightboxContainer.querySelector(".video-controls")

    videoWrapper.addEventListener("mouseenter", () => {
        videoControls.style.opacity = "100";
    });
    videoWrapper.addEventListener("mouseleave", () => {
        videoControls.style.opacity = "0";
    });

    // Rewind button functionality (rewind by 10 seconds)
    const rewindButton = document.getElementById("rewind-button");
    rewindButton.addEventListener("click", () => {
        videoElement.currentTime = Math.max(0, videoElement.currentTime - 3); // Ensure the time doesn't go negative
    });

    // Forward button functionality (fast forward by 10 seconds)
    const forwardButton = document.getElementById("forward-button");
    forwardButton.addEventListener("click", () => {
        videoElement.currentTime = Math.min(videoElement.duration, videoElement.currentTime + 5); // Ensure the time doesn't exceed the video duration
    });

    // Close lightbox if clicked outside the video or the link
    lightboxContainer.addEventListener("click", (e) => {
        if (!e.target.closest('.lightbox-container-element')) {
            document.body.removeChild(lightboxContainer);
        }
    });
}